import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  constructor() {}

  get production(): boolean {
    return environment.production;
  }

  get environmentName(): string {
    return environment.environment;
  }

  get hostingUrl(): string {
    return environment.hostingUrl;
  }

  get aiBaseServerUrl(): string {
    return environment.aiBaseServerUrl;
  }

  get enrichBaseServerUrl(): string {
    return environment.enrichBaseServerUrl;
  }

    get connectBaseServerUrl(): string {
        return environment.connectBaseServerUrl;
    }

  get translationsBaseServerUrl(): string {
    return environment.translationsBaseServerUrl;
  }

    get authBaseServerUrl(): string {
        return environment.authBaseServerUrl;
    }

  get widgetScriptUrl(): string {
    return environment.widgetScriptUrl;
  }

  get frontendDummy(): string {
    return environment.frontendDummy;
  }

  get aiWebServerUrl(): string {
    return environment.aiWebServerUrl;
  }

  get logLevel(): string {
    return environment.logLevel || 'info';
  }

  get metricsEnabled(): boolean {
    return environment.metricsEnabled ?? true;
  }

  get tracingEnabled(): boolean {
    return environment.tracingEnabled ?? true;
  }
} 
